import Spinner from "../spinner/spinner.component";

const DEFAULT_CLASSNAMES = {
  button:
    "flex flex-row shadow active:skew-y-0 hover:skew-y-3 shadow-secondary font-ubuntuBold rounded px-4 py-2 bg-primary text-white hover:bg-secondary",
};

const DefaultButton = ({
  handleClick = () => {},
  loading = false,
  classNames = DEFAULT_CLASSNAMES,
  children,
  otherProps,
}) => {
  return (
    <button
      onClick={handleClick}
      className={classNames?.button || DEFAULT_CLASSNAMES.button}
      {...otherProps}
    >
      {loading ? <Spinner /> : children}
    </button>
  );
};

export default DefaultButton;
